export const TaskTagType = {
    Scheduled: 1,
    OazisIntegration: 2,
    Manual: 3,

    get(type) {
        return this.all().find(x => x.value === type);
    },
    all() {
        return [
            {value: TaskTagType.Manual, translationKey: 'task.tag-type.manual'},
            {value: TaskTagType.Scheduled, translationKey: 'task.tag-type.scheduled'},
            {value: TaskTagType.OazisIntegration, translationKey: 'task.tag-type.oazis-integration'},
        ];
    }
};
